import { Link, NavLink } from "react-router-dom";

import logo from "~/assets/elistech-logo.svg";
import { useAuth, useCurrentUser } from "~/features/auth/hooks";
import { SurveyDetailNavigation } from "~/features/surveys/components";
import { useTranslation } from "~/i18n";
import { cn } from "~/utils";

interface SideBarProps {
  className?: string;
  onClose?: () => void;
  surveyUuid?: string;
}

export function SideBar({
  className,
  onClose,
  surveyUuid,
}: SideBarProps) {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { data: user } = useCurrentUser();

  return (
    <aside
      className={cn("brand-gradient h-full w-full", className)}
    >
      <div className="flex h-full flex-col px-6 pb-6 pt-16 lg:px-14 lg:pt-[110px]">
        <div className="mb-8 lg:mb-[101px]">
          <Link to="/" onClick={onClose}>
            <img
              src={logo}
              alt="ElisTech"
              className="h-8 w-auto max-w-full lg:ml-[3px] lg:h-[46px] lg:w-[221px]"
            />
          </Link>
        </div>

        <nav className="flex flex-col gap-1">
          {surveyUuid ? (
            <SurveyDetailNavigation
              surveyUuid={surveyUuid}
              onNavigate={onClose}
            />
          ) : (
            <div className="lg:-mx-6">
              <NavLink
                to="/surveys"
                onClick={onClose}
                className={({ isActive }) =>
                  [
                    "flex min-h-12 w-full items-center rounded-lg px-3 text-sm font-medium transition-colors",
                    "hover:bg-white/30 hover:text-foreground focus-visible:bg-white/30 focus-visible:text-foreground focus-visible:outline-none",
                    "lg:min-h-[45px] lg:px-0 lg:text-lg lg:font-extrabold lg:leading-9",
                    isActive ? "bg-white/30 text-foreground" : "text-white",
                  ].join(" ")
                }
              >
                <span className="lg:ml-6">
                  {t("navigation.drawer.surveys")}
                </span>
              </NavLink>
            </div>
          )}
          <div className="flex flex-col pt-4 gap-2 border-t border-white/10">
            <span className="min-w-0 break-all px-3 text-sm text-white/80">
              {user?.email}
            </span>
            <button
              type="button"
              onClick={() => void logout()}
              className="cursor-pointer rounded-lg px-3 py-2.5 text-left text-sm font-medium text-white transition-colors hover:bg-white/10 hover:text-white"
            >
              {t("navigation.drawer.logout")}
            </button>
          </div>
        </nav>
      </div>
    </aside>
  );
}
